import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { testimonials, images } from '../data/mock';
import { Quote, Star } from 'lucide-react';

const TestimonialsSection = () => {
  const { t } = useLanguage();

  return (
    <section className="py-24 bg-[#8B1C1C] relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl translate-x-1/2 translate-y-1/2" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-[#fad24b] font-semibold text-sm uppercase tracking-wider mb-4">
            {t('Testimonials', 'Testimoni')}
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
            {t(
              'What Parents Say About Us',
              'Apa Kata Orang Tua Tentang Kami'
            )}
          </h2>
          <p className="text-white/80 text-lg">
            {t(
              'Hear from parents whose children have experienced the joy of ballet at Studio Ballet Izora.',
              'Dengarkan dari orang tua yang anaknya telah merasakan kegembiraan balet di Studio Ballet Izora.'
            )}
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 relative"
            >
              {/* Quote Icon */}
              <Quote className="w-10 h-10 text-[#fad24b] mb-6" />

              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-[#fad24b] text-[#fad24b]" />
                ))}
              </div>

              {/* Text */}
              <p className="text-white/90 leading-relaxed mb-6">
                "{t(testimonial.textEn, testimonial.textId)}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                  <span className="text-white font-bold">
                    {t(testimonial.nameEn, testimonial.nameId).charAt(0)}
                  </span>
                </div>
                <p className="text-white font-semibold">
                  {t(testimonial.nameEn, testimonial.nameId)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
